import React from 'react';
import useSiteBranding from './Components/useSiteBranding';

// Remove any existing favicon links immediately on module load to avoid showing
// the default React favicon while the app initializes. This runs synchronously
// during bundle execution in the browser (only when `document` is available).
try {
  if (typeof document !== "undefined") {
    document
      .querySelectorAll(
        "link[rel='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon'], link[rel='mask-icon']",
      )
      .forEach((el) => el.remove());
  }
} catch (e) {
  // ignore in non-browser environments
}

const BrandingInit = () => {
  // call hook for side-effects (favicon + settings)
  useSiteBranding();
  return null;
};

export default BrandingInit;
